// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1dQsH","label":"Section_label__kBwya","contentWrap":"Section_contentWrap__18c8z","footer":"Section_footer__354Uj","footerInner":"Section_footerInner__3C5iT"};